export const GET_LABELS_WITH_KRN_REQUEST = "GET_LABELS_WITH_KRN_REQUEST";
export const GET_LABELS_WITH_KRN_SUCCESS = "GET_LABELS_WITH_KRN_SUCCESS";
export const GET_LABELS_WITH_KRN_FAILURE = "GET_LABELS_WITH_KRN_FAILURE";

export const labelsWithKrnInitialState: any = {
    labelsWithKrn: [],
    status: "EMPTY",
    error: null,
};

// Action creators
export const getLabelsRequest = () => ({
    type: GET_LABELS_WITH_KRN_REQUEST,
});

export const getLabelsSuccess = (labels: any) => ({
    type: GET_LABELS_WITH_KRN_SUCCESS,
    response: { data: labels },
});

export const getLabelsFailure = (error: any) => ({
    type: GET_LABELS_WITH_KRN_FAILURE,
    error,
});
